import { CssBaseline, ThemeProvider } from '@mui/material';
import './App.css';
import { useEffect } from 'react';
import theme from './mui/theme';
import ASTIDashboard from './components/dashboard/ASTIDashboard';
import { initDemoModeOnLoad } from './helpers/apiHelper';

function App() {

  useEffect(() => {
    document.title = 'Pelmeshka App';
    initDemoModeOnLoad();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ASTIDashboard />
    </ThemeProvider>
  );
}

export default App;
